import { useEffect, useState } from "react";
import { fileUrl } from "@/lib/upload";

export const PHASES = [
  ["idle", "Attesa / Benvenuto"],
  ["playing", "Gioco in corso"],
  ["win", "Vincita"],
  ["lose", "Non vincita"],
];
export const FORMATS = [
  ["landscape", "Orizzontale 16:9 (TV / monitor)"],
  ["portrait", "Verticale 9:16 (totem)"],
  ["square", "Quadrato 1:1 (app / social)"],
];
const BASE_RATIOS = { landscape: 16 / 9, portrait: 9 / 16, square: 1 };

// Formati personalizzati salvati in game.custom_formats: [{key, label, w, h}]
export const allFormats = (custom) => [...FORMATS, ...(custom || []).map((f) => [f.key, `${f.label} (${f.w}:${f.h})`])];
export const formatRatio = (key, custom) => {
  if (BASE_RATIOS[key]) return BASE_RATIOS[key];
  const f = (custom || []).find((x) => x.key === key);
  return f && f.h ? f.w / f.h : 1;
};

export const detectFormat = (w, h, custom) => {
  const r = w / h;
  let best = "square";
  let dist = Infinity;
  for (const [k] of allFormats(custom)) {
    const d = Math.abs(Math.log(r / formatRatio(k, custom)));
    if (d < dist) { dist = d; best = k; }
  }
  return best;
};

export function useViewportFormat(forced, custom) {
  const [f, setF] = useState(() => forced || detectFormat(window.innerWidth, window.innerHeight, custom));
  const customKey = JSON.stringify(custom || []);
  useEffect(() => {
    if (forced) return;
    const on = () => setF(detectFormat(window.innerWidth, window.innerHeight, JSON.parse(customKey)));
    on();
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, [forced, customKey]);
  return f;
}

export const screenSrc = (screens, phase, format) => {
  const s = screens?.[phase];
  if (!s) return null;
  const pick = s[format] || s.landscape || s.portrait || s.square || Object.values(s).find(Boolean);
  if (!pick) return null;
  return fileUrl(pick.file_id) || pick.url || null;
};

const isVideo = (src) => /\.(mp4|webm)(\?|$)/i.test(src || "") || (src || "").includes("video");

export default function ScreenMedia({ screens, phase, format, fit = "cover", className = "", children }) {
  const src = screenSrc(screens, phase, format);
  if (!src) return children || null;
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} data-testid={`screen-media-${phase}`}>
      {isVideo(src) ? (
        <video key={src} src={src} autoPlay muted loop playsInline className="w-full h-full" style={{ objectFit: fit }} />
      ) : (
        <img key={src} src={src} alt={phase} className="w-full h-full" style={{ objectFit: fit }} />
      )}
      {children}
    </div>
  );
}
